module.exports = __webpack_public_path__ + "img/lock.b0143c3c.svg";